"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _jsxRuntime = require("react/jsx-runtime");
var _CartesianGrid;
const BarChartComponent = props => {
  const {
    width = 300,
    height = 200,
    data,
    dataKey = 'name',
    chartDataKey,
    margin = {
      top: 0,
      right: 0,
      left: 0,
      bottom: 0
    },
    barSize = 10,
    barRadius = [10, 10, 0, 0],
    barColor = '#003CFF',
    tooltipStatus = true,
    grid = false,
    labelData = undefined,
    xAxisFontSize = '10px',
    yAxisFontSize = '10px',
    customTooltip,
    series = [],
    layout = 'horizontal',
    xAxisTickFormatter,
    yAxisTickFormatter,
    yAxisTicks = [],
    isStacked = false
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, {
    width: width,
    height: height,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.BarChart, {
      data: data,
      margin: margin,
      layout: layout,
      children: [grid && (_CartesianGrid || (_CartesianGrid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.CartesianGrid, {
        strokeDasharray: "1"
      }))), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.XAxis, {
        dy: 15,
        angle: 0,
        dataKey: dataKey,
        tick: {
          fontFamily: 'Nunito Sans',
          fontSize: xAxisFontSize
        },
        tickFormatter: xAxisTickFormatter,
        tickMargin: 10
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.YAxis, {
        tick: {
          fontFamily: 'Nunito Sans',
          fontSize: yAxisFontSize
        },
        tickFormatter: yAxisTickFormatter,
        ticks: yAxisTicks
      }), tooltipStatus && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Tooltip, {
        content: customTooltip
      }), series ? series.map((serie, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Bar, {
        dataKey: serie.dataKey,
        fill: serie.fill,
        barSize: barSize,
        radius: barRadius,
        stackId: isStacked ? 'a' : undefined,
        background: serie.background ? {
          fill: serie.background
        } : undefined
      }, index)) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Bar, {
        dataKey: chartDataKey,
        maxBarSize: barSize,
        radius: barRadius,
        fill: barColor
      })]
    })
  });
};
var _default = exports.default = BarChartComponent;
module.exports = exports.default;
module.exports.default = exports.default;